import { render, staticRenderFns } from "./SearchResultsTableLayout.vue?vue&type=template&id=794c8b30&scoped=true"
import script from "./SearchResultsTableLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchResultsTableLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchResultsTableLayout.vue?vue&type=style&index=0&id=794c8b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c8b30",
  null
  
)

export default component.exports